import React from "react";
import { ActionIcon } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";

const ReadPageBtn = ({ read: path, disabled }) => {
  const openInNewTab = () => {
    window.open(path, "_blank");
  };

  return (
    <ActionIcon
      variant="filled"
      color="lime"
      aria-label="Read"
      onClick={openInNewTab}
      disabled={disabled}
    >
      <IconEye />
    </ActionIcon>
  );
};

export default ReadPageBtn;
